import { createContext } from 'react'

import { noOp } from '@/utils/helpers'

import { defaultUser } from './constants'
import type { AppContextType, HasuraContextType, UserContextType } from './types'

export const AppContext = createContext<AppContextType>({
  prepass: false,
  dryRun: false,
  requestTimestamp: '',
  showConfetti: noOp,
  setStatusCode: noOp,
  showAppModal: noOp,
})
export const UserContext = createContext<UserContextType>(defaultUser)
export const HasuraContext = createContext<HasuraContextType | null>(null)
